import { useCallback, useState } from "react";
import { api, ApiClientError } from "../../lib/apiClient.js";
import { useI18n } from "../../i18n/index.js";
import { Button } from "../ui/button.js";
import { Modal } from "../ui/modal.js";
import { TextInput } from "../ui/field.js";
import { useToast } from "../../lib/useToast.js";

export function WorkCenterDialog({
  open,
  onOpenChange,
  onCreated,
}: {
  open: boolean;
  onOpenChange(open: boolean): void;
  onCreated(): void;
}) {
  const { push } = useToast();
  const { t } = useI18n();
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = useCallback(async () => {
    setBusy(true);
    try {
      await api.createWorkCenter({ code, name, hourlyRate });
      push(t("catalog.workCenter.addedToast"), name);
      setCode("");
      setName("");
      setHourlyRate("");
      onOpenChange(false);
      onCreated();
    } catch (err) {
      if (err instanceof ApiClientError) push(err.message, undefined, "danger");
    } finally {
      setBusy(false);
    }
  }, [code, hourlyRate, name, onCreated, onOpenChange, push, t]);

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t("catalog.workCenter.addTitle")}
      footer={
        <>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={submit}
            disabled={busy || !code.trim() || !name.trim()}
          >
            {busy ? t("common.saving") : t("catalog.workCenter.saved")}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <TextInput
          label={t("common.fields.code")}
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <TextInput
          label={t("common.fields.name")}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextInput
          label={t("catalog.column.hourlyRate")}
          value={hourlyRate}
          hint={t("catalog.workCenter.rateHint")}
          onChange={(e) => setHourlyRate(e.target.value)}
        />
      </div>
    </Modal>
  );
}
